import { MedicalPaOrder } from "../../../../data-model/medicalPaOrdersModel";
import {
  deleteNestedValue,
  setNestedValue,
} from "../../../../utils/getNestedValue";
import { getParentPathBeforeLastBracket } from "../../../../utils/getParentPathBeforeLastBreacket";
import { getUpdatedFormDataWithFilledValues } from "../../../pharmaPaForm/utils/getUpdatedFormDataWithFilledValues";

export const createOrderDataFromContextFormData = (
  formFieldsData: any,
  singleMedicalPaOrder: MedicalPaOrder,
) => {
  const onlyFieldsDataValue =
    getUpdatedFormDataWithFilledValues(formFieldsData);

  let data = { ...singleMedicalPaOrder };
  for (const key in onlyFieldsDataValue) {
    const parentPath = getParentPathBeforeLastBracket(key);

    if (parentPath) {
      data = deleteNestedValue(data, parentPath);
    }
  }
  for (const key in onlyFieldsDataValue) {
    data = setNestedValue(data, key, onlyFieldsDataValue[key]);
  }

  return data;
};
